import React from 'react';
import styled from 'styled-components';
import Text from './EPL_Text';

const LoanSummaryItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 1rem;
    .lsdip-loan-summary-detail-item-title {
        color: #674B4B;
    }
    .lsdip-loan-summary-detail-item-value {
        color: #674B4B;
    }
`;

const LoanSummaryTextItem = ({ id = '', title, value, titleStyle, valueStyle }) => {
    return (
        <LoanSummaryItemWrapper id={`lsdip-loan-summary-detail-item-${id}`}>
            <Text class_name="lsdip-loan-summary-detail-item-title" style={{...titleStyle}} text={title} size="h6" />
            <Text class_name="lsdip-loan-summary-detail-item-value" style={{...valueStyle}} text={value} size="h6" />
        </LoanSummaryItemWrapper>
    );
};

export default LoanSummaryTextItem;